import useTickedAllSubAccounts from '../useTickedAllSubAccounts';
import { useMemo } from 'react';
import {
	useOpenSubaccountSelectPanelHotkey,
	useSubAccountNumberSwitchHotkeys,
} from './useSubAccountSwitchHotkeys';

export const useGlobalHotkeySetup = () => {
	const subAccounts = useTickedAllSubAccounts();
	const subAccountsOrdered = useMemo(() => {
		return subAccounts.sort((a, b) => {
			// sort by poolId first, then by userId
			if (a.poolId === b.poolId) {
				return a.userId - b.userId;
			}
			return a.poolId - b.poolId;
		});
	}, [subAccounts]);

	// hotkeys to switch sub accounts 0-9
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 0);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 1);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 2);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 3);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 4);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 5);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 6);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 7);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 8);
	useSubAccountNumberSwitchHotkeys(subAccountsOrdered, 9);

	useOpenSubaccountSelectPanelHotkey(subAccountsOrdered);
};
